import type { IconSvgObject } from './types';

const ArrowDown01Icon: IconSvgObject = [
  ["path", { d: "M18 9.00005C18 9.00005 13.5811 15 12 15C10.4188 15 6 9 6 9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default ArrowDown01Icon;
